(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tk-popup-newsletter"]) return;
  try {
    
  class MoPopupNewsletter extends HTMLElement {
    connectedCallback() {
      this.storageKey = this.dataset.storageKey || 'tk_popup_newsletter_v1';
      this.delay = (parseInt(this.dataset.delay, 10) || 15) * 1000;
      this.redisplayMs = (parseInt(this.dataset.redisplayDays, 10) || 14) * 86400000;
      this.designMode = this.dataset.designMode === 'true';
      this.sectionId = this.dataset.sectionId || '';

      this.apiBase = this.dataset.apiBase || '';
      this.shop = this.dataset.shop || '';

      this.card = this.querySelector('.tk-popup__card');
      this.backdrop = this.querySelector('.tk-popup__backdrop');
      this.teaser = this.querySelector('.tk-popup__teaser');
      this.form = this.querySelector('.tk-popup__form');
      this.errorEl = this.querySelector('[data-tk-popup-error]');
      this.successStep = this.querySelector('[data-tk-popup-step="success"]');
      this.initialStep = this.querySelector('[data-tk-popup-step="initial"]');

      this.bindEvents();
      this.init();
    }

    disconnectedCallback() {
      this.disarmTriggers();
      clearTimeout(this.closeTimer);
    }

    init() {
      // V editoru theme NEOTVÍRÁME popup automaticky (jinak zaskočí merchanta
      // při každém načtení/refreshi editoru). Místo toho ho ukážeme jen když
      // merchant klikne na tuhle sekci v levém panelu (shopify:section:select)
      // a zavřeme při odkliknutí (shopify:section:deselect).
      if (this.designMode) {
        this.hidden = false;
        document.addEventListener('shopify:section:select', (e) => {
          if (e.detail.sectionId === this.sectionId) this.open(true);
        });
        document.addEventListener('shopify:section:deselect', (e) => {
          if (e.detail.sectionId === this.sectionId) this.close();
        });
        return;
      }

      const state = this.readState();
      if (state.subscribed) return;

      if (state.dismissedAt && (Date.now() - state.dismissedAt) < this.redisplayMs) {
        return;
      }

      this.hidden = false;

      if (state.minimized) {
        this.showTeaser();
      } else {
        this.armTriggers();
      }
    }

    // Popup otevře PRVNÍ ze tří signálů: časovač, 40 % odrolování,
    // nebo pokus o odchod (desktop — myš vyjede nahoru z viewportu).
    armTriggers() {
      const fire = () => {
        this.disarmTriggers();
        this.open();
      };
      this.openTimer = setTimeout(fire, this.delay);
      this.onScrollTrigger = () => {
        const doc = document.documentElement;
        const max = doc.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max >= 0.4) fire();
      };
      window.addEventListener('scroll', this.onScrollTrigger, { passive: true });
      if (window.matchMedia('(pointer: fine)').matches) {
        this.onExitTrigger = (e) => {
          if (!e.relatedTarget && e.clientY <= 0) fire();
        };
        document.addEventListener('mouseout', this.onExitTrigger);
      }
    }

    disarmTriggers() {
      clearTimeout(this.openTimer);
      if (this.onScrollTrigger) {
        window.removeEventListener('scroll', this.onScrollTrigger);
        this.onScrollTrigger = null;
      }
      if (this.onExitTrigger) {
        document.removeEventListener('mouseout', this.onExitTrigger);
        this.onExitTrigger = null;
      }
    }

    bindEvents() {
      this.querySelectorAll('[data-tk-popup-close]').forEach(el => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.minimize();
        });
      });

      this.teaser?.addEventListener('click', (e) => {
        if (e.target.closest('[data-tk-popup-dismiss]')) {
          e.preventDefault();
          e.stopPropagation();
          this.dismiss();
          return;
        }
        this.open();
      });

      this.querySelectorAll('[data-tk-popup-dismiss]').forEach(el => {
        el.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.dismiss();
          }
        });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.classList.contains('tk-popup--open')) {
          this.minimize();
        }
      });

      // Focus trap — Tab uvnitř otevřeného dialogu cyklí, ven se nedostane.
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab' || !this.classList.contains('tk-popup--open')) return;
        const focusables = Array.from(this.card.querySelectorAll(
          'button, a[href], input, [tabindex]:not([tabindex="-1"])'
        )).filter(el =>
          !el.hidden && !el.disabled && el.tabIndex !== -1 &&
          !el.closest('[hidden]') && el.offsetParent !== null
        );
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      // Submit jde přes fetch na API platformy — stránka nikam nenaviguje.
      this.form?.addEventListener('submit', (e) => this.handleSubmit(e));

      const copyBtn = this.querySelector('[data-tk-popup-copy]');
      copyBtn?.addEventListener('click', () => this.copyCode(copyBtn));
    }

    readState() {
      try {
        return JSON.parse(localStorage.getItem(this.storageKey) || '{}');
      } catch { return {}; }
    }

    writeState(patch) {
      try {
        const state = { ...this.readState(), ...patch };
        localStorage.setItem(this.storageKey, JSON.stringify(state));
      } catch {}
    }

    open(skipDelay) {
      this.disarmTriggers();
      this.hideTeaser();
      this.classList.add('tk-popup--open');
      if (!this.designMode) document.body.style.overflow = 'hidden';
      // Fokus rovnou do pole s e-mailem (dřívější důvod nefokusovat — aktivace
      // Shopify reCAPTCHA — odpadl, formulář jede na API platformy). Na success
      // kroku fokus na kupon/CTA.
      const focusTarget = this.successStep && !this.successStep.hidden
        ? this.querySelector('[data-tk-popup-copy]:not([hidden]), .tk-popup__cta:not([hidden])')
        : this.querySelector('.tk-popup__input');
      setTimeout(() => focusTarget?.focus({ preventScroll: true }), skipDelay ? 0 : 380);
    }

    close() {
      this.classList.remove('tk-popup--open');
      document.body.style.overflow = '';
    }

    minimize() {
      const state = this.readState();
      if (state.subscribed) {
        this.close();
        this.hideTeaser();
        return;
      }

      this.close();
      if (this.designMode) return;

      this.writeState({ minimized: true });
      setTimeout(() => this.showTeaser(), 320);
    }

    dismiss() {
      this.close();
      this.hideTeaser();
      if (this.designMode) return;
      this.writeState({ minimized: false, dismissedAt: Date.now() });
    }

    showTeaser() {
      if (!this.teaser) return;
      this.teaser.hidden = false;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.teaser.classList.add('tk-popup__teaser--show'));
      });
    }

    hideTeaser() {
      if (!this.teaser) return;
      this.teaser.classList.remove('tk-popup__teaser--show');
      setTimeout(() => {
        if (this.teaser && !this.teaser.classList.contains('tk-popup__teaser--show')) {
          this.teaser.hidden = true;
        }
      }, 450);
    }

    handleSubmit(e) {
      e.preventDefault();
      if (this.submitting) return;

      const submitBtn = this.form.querySelector('[data-tk-popup-submit]');
      const emailInput = this.form.querySelector('input[type="email"]');
      if (this.errorEl) this.errorEl.hidden = true;

      const email = (emailInput?.value || '').trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.showError(this.dataset.invalidEmailMsg || 'Please enter a valid email.');
        emailInput?.focus();
        return;
      }

      this.submitting = true;
      submitBtn?.setAttribute('aria-busy', 'true');
      this.submitEmail(email).finally(() => {
        submitBtn?.removeAttribute('aria-busy');
        this.submitting = false;
      });
    }

    // Jazyk stránky → jazyk e-mailu s kódem i hlášek z API. Čte se dynamicky
    // z <html lang>, NIKDY natvrdo — jinak dojde návštěvníkovi EN stránky
    // český mail. Neznámý jazyk se neposílá (platforma má vlastní default).
    pageLocale() {
      const lang = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
      return ['cs', 'sk', 'en'].includes(lang) ? lang : '';
    }

    // Anti-spam token — na tomhle eshopu zatím vypnutý, ale posílá se VŽDY,
    // ať jde ochrana v hubu kdykoli zapnout bez zásahu do webu. Token je vázaný
    // na IP a platí 2 h → bere se čerstvý při každém odeslání, necachovat.
    async fetchChallenge() {
      try {
        const r = await fetch(this.apiBase + '/welcome/challenge', { credentials: 'omit' });
        const d = await r.json();
        return (d && d.ok && d.token) || '';
      } catch {
        return '';
      }
    }

    async postWelcome(payload) {
      const r = await fetch(this.apiBase + '/welcome', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify(payload),
      });
      let data = {};
      try { data = await r.json(); } catch {}
      return { status: r.status, data };
    }

    async submitEmail(email) {
      try {
        const payload = {
          shop: this.shop,
          email,
          hp_check: this.form.querySelector('input[name="hp_check"]')?.value || '',
          source: 'popup',
        };
        const locale = this.pageLocale();
        if (locale) payload.locale = locale;

        let res = await this.postWelcome({ ...payload, challenge: await this.fetchChallenge() });

        // 403 challenge = chybějící/vypršelý token → čerstvý token a JEDNO opakování.
        if (res.status === 403 && res.data.code === 'challenge') {
          res = await this.postWelcome({ ...payload, challenge: await this.fetchChallenge() });
        }

        if (res.data.ok) {
          this.handleSuccess(res.data);
          return;
        }

        // Adresa už u nás nakoupila (sleva jen na první nákup) — vlídně říct,
        // za chvíli zavřít a už nikdy neotravovat.
        if (res.status === 409 && res.data.code === 'already_customer') {
          this.showError(res.data.error || this.dataset.errorNetwork || '', true);
          this.writeState({ subscribed: true, minimized: false });
          clearTimeout(this.closeTimer);
          this.closeTimer = setTimeout(() => {
            this.close();
            this.hideTeaser();
          }, 4000);
          return;
        }

        // 400/403/429/500 — pole "error" chodí lokalizované, zobrazit přímo.
        this.showError(res.data.error || this.dataset.errorNetwork || '');
      } catch {
        // Výpadek API nesmí rozbít stránku — tichá hláška v okně.
        this.showError(this.dataset.errorNetwork || '');
      }
    }

    showError(msg, notice) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.classList.toggle('tk-popup__error--notice', !!notice);
      this.errorEl.hidden = !msg;
    }

    // data = úspěšná odpověď API. Varianty:
    //  - {code, url, message, validUntil} → kupon + odkaz na nákup
    //  - {needConfirm, message}           → kód dorazí až po potvrzení mailu
    //  - {}                               → tiché přijetí, kód přijde mailem
    handleSuccess(data) {
      data = data || {};
      // TK GTM tracking (assets/tk-track.js) -> newsletter_signup
      try { document.dispatchEvent(new CustomEvent('tk:newsletter-signup', { detail: { source: 'popup' } })); } catch (e) {}
      const heading = this.querySelector('[data-tk-popup-success-heading]');
      const body = this.querySelector('[data-tk-popup-success-body]');
      const codeBtn = this.querySelector('[data-tk-popup-copy]');
      const codeValue = this.querySelector('[data-tk-popup-code-value]');
      const validEl = this.querySelector('[data-tk-popup-valid]');
      const applyLink = this.querySelector('[data-tk-popup-apply]');
      const skipBtn = this.querySelector('[data-tk-popup-skip]');

      const code = data.code || '';

      if (code && codeBtn && codeValue) {
        codeValue.textContent = code;
        codeBtn.dataset.code = code;
        codeBtn.hidden = false;
      } else if (heading && this.dataset.confirmHeading) {
        // Bez kódu (needConfirm / tiché přijetí) by "tady je tvůj kód:" lhalo.
        heading.textContent = this.dataset.confirmHeading;
      }

      if (body) {
        const text = data.message || (code ? '' : (this.dataset.sentMsg || ''));
        body.textContent = text;
        body.hidden = !text;
      }

      if (validEl && data.validUntil) {
        const until = new Date(data.validUntil);
        if (!isNaN(until)) {
          validEl.textContent = (this.dataset.validMsg || '') + ' ' +
            until.toLocaleDateString(document.documentElement.lang || undefined);
          validEl.hidden = false;
        }
      }

      if (code && data.url && applyLink) {
        applyLink.href = data.url;
        applyLink.hidden = false;
      } else if (skipBtn) {
        // Bez odkazu je zavření jediná akce → povýšit na plné CTA.
        skipBtn.classList.remove('tk-popup__cta-skip');
        skipBtn.classList.add('tk-popup__cta');
        if (this.dataset.closeMsg) skipBtn.textContent = this.dataset.closeMsg;
      }

      if (this.initialStep) this.initialStep.hidden = true;
      if (this.successStep) this.successStep.hidden = false;
      this.writeState({ subscribed: true, minimized: false });
      const focusTarget = this.querySelector('[data-tk-popup-copy]:not([hidden]), .tk-popup__cta:not([hidden])');
      setTimeout(() => focusTarget?.focus({ preventScroll: true }), 100);
    }

    copyCode(btn) {
      const code = btn.dataset.code || '';
      if (!code) return;
      const labelHost = btn.querySelector('[data-tk-popup-copy-label]');
      const labelWrap = labelHost?.querySelector('span');
      const copyText = labelHost?.dataset.copyText || (labelWrap?.textContent ?? 'Copy');
      const copiedText = labelHost?.dataset.copiedText || 'Copied';
      const done = () => {
        btn.classList.add('is-copied');
        if (labelWrap) labelWrap.textContent = copiedText;
        setTimeout(() => {
          btn.classList.remove('is-copied');
          if (labelWrap) labelWrap.textContent = copyText;
        }, 2000);
      };
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(() => {
          this.fallbackCopy(code); done();
        });
      } else {
        this.fallbackCopy(code); done();
      }
    }

    fallbackCopy(text) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch {}
      document.body.removeChild(ta);
    }
  }

  if (!customElements.get('tk-popup-newsletter')) {
    customElements.define('tk-popup-newsletter', MoPopupNewsletter);
  }

  } catch(e) { console.error(e); }
})();
})();
